import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchGroupTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'group_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveGroupType(app, dataToSave) {
  const { user={}, data } = dataToSave;
  let taskTypeData = {
    doc_type: DocType.GROUP_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined)
  };

  return common.saveDoc(app, {
    source: data,
    doc: taskTypeData,
    user,
  });

}

export function deleteGroupType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: 'group_type'
  });
}

export function fetchGroupTypeById(app, params) {
  const { id } = params;
  const docType = 'group_type';
  return common.getDoc(app, { id, docType });
}
